/* Custom theme scripts */

/* Turn the star rating label "1 review" / "12 reviews" into "(1)" / "(12)".
   Only writes when the text actually changes — writing unconditionally would
   feed the observer below its own mutations and loop forever. */
function formatRatingLabel() {
  document.querySelectorAll('.kl_reviews__star_rating_widget__label').forEach((el) => {
    var match = el.textContent.match(/^\s*([\d.,]+)\s*reviews?\s*$/i);
    if (match && el.textContent !== '(' + match[1] + ')') {
      el.textContent = '(' + match[1] + ')';
    }
  });
}

/* The Klaviyo rating widget is injected asynchronously and re-renders on
   collection filtering / pagination, so we watch for it — but coalesce all
   mutations in a frame into a single pass to keep the page responsive. */
function initFormatRatingLabel() {
  var scheduled = false;

  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      formatRatingLabel();
    });
  }

  schedule();

  new MutationObserver(schedule).observe(document.body, {
    childList: true,
    subtree: true,
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initFormatRatingLabel);
} else {
  initFormatRatingLabel();
}
